import type { WebSite, WithContext } from 'schema-dts';

import { AHM_WEBSITE } from '../../constants';

const buildWebsiteSchema = (): WithContext<WebSite> => ({
  '@context': 'https://schema.org',
  '@id': AHM_WEBSITE.ID,
  '@type': 'WebSite',
  name: AHM_WEBSITE.NAME,
  publisher: AHM_WEBSITE.PUBLISHER,
  url: AHM_WEBSITE.URL,
});

export default buildWebsiteSchema;
